<template>
    <div>
        <login></login>
        <div class="theme-layout" id="scrollup" v-if="!this.$route.query.disableHeader">
            <div class="responsive-header">
                <div class="responsive-menubar">
                    <div class="res-logo">
                        <router-link to="/">
                            <img v-bind:src="logo">
                        </router-link>
                    </div>
                    <div class="menu-resaction">
                        <div class="res-openmenu" @click="openMobileMenu()">
                            <img src="images/icon.png" alt=""/> Menu
                        </div>
                        <div class="res-closemenu" @click="closeMobileMenu()">
                            <img src="images/icon2.png" alt=""/> Close
                        </div>
                    </div>
                </div>
                <div class="responsive-opensec">
                    <div class="btn-extars">
                        <ul class="account-btns" v-if="loggedIn">
                            <li class="signup-popup" v-on:click="logoutClicked">
                                <i class="fas fa-sign-out-alt"></i> Logout
                            </li>
                        </ul>
                        <ul class="account-btns" v-else>
                            <li class="signin-popup" @click="openLoginModal()">
                                <a href="javascript:;">
                                    <i class="fas fa-key"></i> Login
                                </a>
                            </li>
                            <li @click="closeMobileMenu()">
                                <router-link to="/signup">
                                    <i class="fas fa-sign-in-alt"></i> Signup
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="responsivemenu" v-if="loggedIn">
                        <ul v-if="this.$store.getters.getUserType === 'Individual'">
<!--                            <li v-if="this.$store.getters.getPreferences['show_jobs']">-->
<!--                                <router-link to="/">Colleges</router-link>-->
<!--                            </li>-->
<!--                            <li>-->
<!--                                <router-link to="/students">Students</router-link>-->
<!--                            </li>-->
                            <li v-if="this.$store.getters.getPreferences['show_jobs']" @click="closeMobileMenu()">
                                <router-link to="/dashboard/jobs">Jobs</router-link>
                            </li>
                            <li v-if="this.$store.getters.getPreferences['show_internships']" @click="closeMobileMenu()">
                                <router-link to="/dashboard/internships">Internships</router-link>
                            </li>
                            <li v-if="this.$store.getters.getPreferences['show_jobs'] && this.$store.getters.getPreferences['show_internships']" @click="closeMobileMenu()">
                                <router-link to="/companies">Companies</router-link>
                            </li>
                            <li v-if="this.$store.getters.getUser['education_loan']" @click="closeMobileMenu()">
                                <router-link to="/dashboard/education-loan">Education Loan</router-link>
                            </li>
                            <li @click="closeMobileMenu()">
                              <router-link to="/dashboard/webinars">Webinars</router-link>
                            </li>
                            <li>
                                <router-link to="/quizzes">Quizzes</router-link>
                            </li>
                        </ul>
                        <ul v-else-if="this.$store.getters.getUserType != 'teacher'">
                            <li v-if="this.$store.getters.getUser['business_activity'] != 'School'" @click="closeMobileMenu()">
                                <router-link to="/dashboard/viewcompanies">Companies</router-link>
                            </li>
                            <li v-if="this.$store.getters.getPreferences['show_jobs']" @click="closeMobileMenu()">
                                <router-link to="/dashboard/all-jobs">Jobs</router-link>
                            </li>
                            <li v-if="this.$store.getters.getPreferences['show_internships']" @click="closeMobileMenu()">
                                <router-link to="/dashboard/all-internships">Internships</router-link>
                            </li>
                            <li @click="closeMobileMenu()">
                                <router-link to="/dashboard/viewcandidates">Students</router-link>
                            </li>
                            <li v-if="this.$store.getters.getUser['education_loan']" @click="closeMobileMenu()">
                              <router-link to="/dashboard/loan-applicants">Education Loan</router-link>
                            </li>
                            <li @click="closeMobileMenu()">
                              <router-link to="/dashboard/webinars">Webinars</router-link>
                            </li>
                            <li @click="closeMobileMenu()">
                                <router-link to="/quizzes">Quizzes</router-link>
                            </li>
<!--                            <li>-->
<!--                                <router-link to="/dashboard">Dashboard</router-link>-->
<!--                            </li>-->
                        </ul>
                    </div>
                    <div class="responsivemenu" v-else>
                        <ul>
                            <li @click="closeMobileMenu()">
                                <router-link to="/">For Students</router-link>
                            </li>
                            <li @click="closeMobileMenu()">
                                <router-link to="/colleges">For Colleges</router-link>
                            </li>
                            <li>
                                <a href="/education-loan/apply">
                                    Apply For Education Loan
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <header class="stick-top forsticky">
                <div class="menu-sec">
                    <div class="container">
                        <div class="logo">
                            <router-link to="/">
                                <img class="hidesticky" v-bind:src="logo">
                                <img class="showsticky" v-bind:src="logo">
                            </router-link>
                        </div><!-- Logo -->
                        <div class="btn-extars" v-if="!loggedIn">
                            <ul class="account-btns">
                                <li class="signin-popup" @click="openLoginModal()">
                                    <a href="javascript:;">
                                        <i class="fas fa-key"></i> Login
                                    </a>
                                </li>
                            </ul>
                            <ul class="account-btns">
                                <li>
                                    <router-link to="/signup">
                                        <i class="fas fa-sign-in-alt"></i> Signup
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                        <nav v-if="loggedIn">
                            <ul v-if="this.$store.getters.getUserType === 'Individual'">
                                <li v-if="this.$store.getters.getPreferences['show_jobs']">
                                    <router-link to="/dashboard/jobs">Jobs</router-link>
                                </li>
                                <li v-if="this.$store.getters.getPreferences['show_internships']">
                                    <router-link to="/dashboard/internships">Internships</router-link>
                                </li>
                                <li v-if="this.$store.getters.getPreferences['show_jobs'] && this.$store.getters.getPreferences['show_internships']">
                                    <router-link to="/companies">Companies</router-link>
                                </li>
                                <li v-if="this.$store.getters.getUser['education_loan']">
                                    <router-link to="/dashboard/education-loan">Education Loan</router-link>
                                </li>
                                <li>
                                    <router-link to="/dashboard/webinars">Webinars</router-link>
                                </li>
                                <li>
                                    <router-link to="/quizzes">Quizzes</router-link>
                                </li>
                            </ul>
                            <ul v-else-if="this.$store.getters.getUserType != 'teacher'">
                                <li v-if="this.$store.getters.getUser['business_activity'] != 'School'">
                                    <router-link to="/dashboard/viewcompanies">Companies</router-link>
                                </li>
                                <li v-if="this.$store.getters.getPreferences['show_jobs']">
                                    <router-link to="/dashboard/all-jobs">Jobs</router-link>
                                </li>
                                <li v-if="this.$store.getters.getPreferences['show_internships']">
                                    <router-link to="/dashboard/all-internships">Internships</router-link>
                                </li>
                                <li>
                                    <router-link to="/dashboard/viewcandidates">Students</router-link>
                                </li>
                                <li v-if="this.$store.getters.getUser['education_loan']">
                                  <router-link to="/dashboard/loan-applicants">Education Loan</router-link>
                                </li>
                                <li>
                                  <router-link to="/dashboard/webinars">Webinars</router-link>
                                </li>
                                <li>
                                    <router-link to="/quizzes">Quizzes</router-link>
                                </li>
<!--                                <li>-->
<!--                                    <router-link to="/dashboard">Dashboard</router-link>-->
<!--                                </li>-->
                            </ul>
                        </nav>
                        <nav v-else>
                            <ul>
                                <li>
                                    <router-link to="/">For Students</router-link>
                                </li>
                                <li>
                                    <router-link to="/colleges">For Colleges</router-link>
                                </li>
                                <li>
                                    <a href="/education-loan/apply">
                                        Apply For Education Loan
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </header>
        </div>
        <router-view></router-view>
        <section class="footer" v-if="!this.$route.query.disableFooter">
            <div class="container">
                <div class="row">
                    <div class="col-md-4">
                        <div class="powered-by">Powered By</div>
                        <div class="ey-logo">
                            <a href="https://www.empoweryouth.com/" target="_blank"><img src="/images/index/ey_logo_com.png"></a>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="social-links">
                            <div class="social-heading">Social Links</div>
                            <div class="social-buttons">
                                <!-- facebook  Button -->
                                <a href="https://www.facebook.com/MY-E-Campus-101163728174771/?modal=admin_todo_tour" target="blank" class="social-margin">
                                    <div class="social-icon facebook">
                                        <i class="fab fa-facebook-f" aria-hidden="true"></i>
                                    </div>
                                </a>
                                <!-- pinterest Button -->
                                <a href="https://www.instagram.com/my_e_campus/" target="blank" class="social-margin">
                                    <div class="social-icon pinterest">
                                        <i class="fab fa-instagram"></i>
                                    </div>
                                </a>
                                <!-- LinkedIn Button -->
                                <a href="https://www.linkedin.com/company/my-ecampus/about/?viewAsMember=true" class="social-margin" target="blank">
                                    <div class="social-icon linkedin">
                                        <i class="fab fa-linkedin-in" aria-hidden="true"></i>
                                    </div>
                                </a>

                                <!-- TwitterButton -->
                                <a href="https://twitter.com/my_ecampus" target="blank" class="social-margin">
                                    <div class="social-icon twitter">
                                        <i class="fab fa-twitter" aria-hidden="true"></i>
                                    </div>
                                </a>
                            </div>

                        </div>

                    </div>
                    <div class="col-md-4">
                        <div class="powered-by">Contact Us</div>
                        <div class="support-id">
                            <a href="mailto:support@empoweryouth.com">support@empoweryouth.com</a>
                        </div>
                        <div class="support-number" v-if="this.$store.getters.getUserType != 'Individual'">
                          <i class="fas fa-phone-alt"></i> <a href="tel:+919115497165s"> +91-9115497165</a>
                        </div>
                        <div class="support-number" v-if="this.$store.getters.getUserType != 'Individual'">
                          <i class="fas fa-phone-alt"></i> <a href="tel:+917009076638"> +91-7009076638</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import login from './Login.vue'
    import toastr from "../../public/js/toastr";

    export default {
        components: {
            login
        },
        data: function () {
            return {
                logo: "/images/e_campus_logo.png",
            }
        },
        mounted() {

        },
        methods: {
            openLoginModal() {
                $('#myModal').css({"display": "block"});
            },
            logoutClicked() {
                this.$store.dispatch("setLoggedOut");
                toastr.success('Logging out soon', 'Logged Out');
                window.location.replace("/");
            },
            openMobileMenu() {
                $('.responsive-header').addClass('active');
                $('.responsive-opensec').slideDown();
                $('.res-closemenu').removeClass('active')
                $('.res-openmenu').addClass('active');
            },
            closeMobileMenu() {
                $('.responsive-header').removeClass('active');
                $('.responsive-opensec').slideUp();
                $('.res-openmenu').removeClass('active')
                $('.res-closemenu').addClass('active');
            },
        },
        computed: {
            loggedIn: function () {
                return this.$store.getters.getAuthState;
            }
        }
    }
</script>